function n(e) {
  return e;
}
export {
  n as createInjectionKey
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_utils/vue/create-injection-key.js
// module id = 32
// module chunks = 67